import { render, staticRenderFns } from "./TarjetonesIndex.vue?vue&type=template&id=09ed8640"
import script from "./TarjetonesIndex.vue?vue&type=script&lang=js"
export * from "./TarjetonesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports